import { render } from "./SubunternehmerFields.vue?vue&type=template&id=3dc57366"
import script from "./SubunternehmerFields.vue?vue&type=script&lang=js"
export * from "./SubunternehmerFields.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__